export const isValidConfigKey = (key) =>
  typeof key === "string" && /^[a-z0-9][a-z0-9_-]*$/i.test(key.trim());

export const configKeyFromSplat = (splat) => {
  if (typeof splat !== "string") return null;
  const key = splat.trim();
  return isValidConfigKey(key) ? key : null;
};

export const staticDataPath = (companyId, key) =>
  `/admin/${companyId}/settings/static-data${key == null ? "" : `/${key}`}`;

export const appendCreateOption = (filteredOptions, inputValue, allOptions) => {
  const input = (inputValue || "").trim();
  if (!isValidConfigKey(input)) return filteredOptions;
  if ((allOptions || []).some((option) => option.key === input)) {
    return filteredOptions;
  }
  return [
    ...filteredOptions,
    {
      key: input,
      displayName: `Create new config "${input}"`,
      isNewKey: true,
    },
  ];
};

export const deriveKeyFromName = (name) => {
  if (typeof name !== "string") return "";
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
};

export const displayNameForKey = (key) => {
  if (typeof key !== "string" || key === "") return "";
  return key
    .trim()
    .split("_")
    .map(
      (token) =>
        token.substring(0, 1).toUpperCase() + token.substring(1).toLowerCase()
    )
    .join(" ");
};

export const mergeConfigKeyOptions = (registryOptions, existingKeys) => {
  const registry = registryOptions ?? [];
  const registryKeys = new Set(registry.map((option) => option.key));
  const adHoc = [...new Set(existingKeys ?? [])]
    .filter((key) => !registryKeys.has(key))
    .sort()
    .map((key) => ({ key, isAdHoc: true }));
  return [...registry, ...adHoc];
};

export const optionKey = (option) => {
  if (typeof option === "string") {
    const trimmed = option.trim();
    return trimmed === "" ? null : trimmed;
  }
  return option?.key ?? null;
};
